export default function checkModule(modules: { name: string }[], moduleName: string) {
  if (!moduleName) return false;
  if (modules.find((module) => module.name === moduleName)) {
    return true;
  }

  return false;
}
